"use client";

import React from "react";
import { Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
export default function KeepUpWithUs() {
  return <section id="keep-up-with-us" className="dark bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      <div className="max-w-[600px] mx-auto w-full relative z-10">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-black tracking-tighter uppercase text-white !m-0 !w-[600px] md:text-5xl">SUBSCRIBE FOR FUTURE EVENTS</h2>
          
        </div>

        <FormProvider formId="keep_up_form_home" sectionName="keep-up-with-us" defaultValues={{
        first_name: "",
        last_name: "",
        email: "",
        phone: ""
      }} validationRules={{
        first_name: {
          required: true
        },
        last_name: {
          required: true
        },
        email: {
          required: true,
          pattern: "email"
        },
        phone: {
          required: true,
          pattern: "phone"
        }
      }} submitText="JOIN" successMessage="Welcome to the inner circle. We'll be in touch." errorMessage="Access denied. Please verify your details and try again." className="w-full">
          <KeepUpForm />
        </FormProvider>
      </div>
    </section>;
}
function KeepUpForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 border-2 border-white bg-neutral-900/50 text-center animate-in fade-in zoom-in duration-500">
        <h3 className="text-2xl font-bold text-white mb-2 uppercase tracking-wide">
          Access Granted
        </h3>
        <p className="text-neutral-300 mb-6">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="border-white text-white hover:bg-white hover:text-black uppercase tracking-widest font-bold rounded-none px-8">
          Register Another
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="first_name" rules={{
        required: "First name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white uppercase text-xs font-bold tracking-widest ml-1">
                First Name
              </FormLabel>
              <FormControl>
                <Input placeholder="John" {...field} className="bg-transparent border-2 border-white text-white placeholder:text-neutral-600 rounded-none h-12 focus-visible:ring-0 focus-visible:border-white focus-visible:bg-neutral-900/30 transition-all" />
              </FormControl>
              <FormMessage className="text-red-600 font-bold uppercase text-xs tracking-wide" />
            </FormItem>} />

        <FormField control={control} name="last_name" rules={{
        required: "Last name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white uppercase text-xs font-bold tracking-widest ml-1">
                Last Name
              </FormLabel>
              <FormControl>
                <Input placeholder="Doe" {...field} className="bg-transparent border-2 border-white text-white placeholder:text-neutral-600 rounded-none h-12 focus-visible:ring-0 focus-visible:border-white focus-visible:bg-neutral-900/30 transition-all" />
              </FormControl>
              <FormMessage className="text-red-600 font-bold uppercase text-xs tracking-wide" />
            </FormItem>} />
      </div>

      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-white uppercase text-xs font-bold tracking-widest ml-1">
              Email Address
            </FormLabel>
            <FormControl>
              <Input type="email" placeholder="john.doe@example.com" {...field} className="bg-transparent border-2 border-white text-white placeholder:text-neutral-600 rounded-none h-12 focus-visible:ring-0 focus-visible:border-white focus-visible:bg-neutral-900/30 transition-all" />
            </FormControl>
            <FormMessage className="text-red-600 font-bold uppercase text-xs tracking-wide" />
          </FormItem>} />

      <FormField control={control} name="phone" rules={{
      required: "Phone number is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-white uppercase text-xs font-bold tracking-widest ml-1">
              Phone Number
            </FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+61 4XX XXX XXX" {...field} className="bg-transparent border-2 border-white text-white placeholder:text-neutral-600 rounded-none h-12 focus-visible:ring-0 focus-visible:border-white focus-visible:bg-neutral-900/30 transition-all" />
            </FormControl>
            <FormMessage className="text-red-600 font-bold uppercase text-xs tracking-wide" />
          </FormItem>} />

      {submitError && <div className="p-4 border border-red-600 bg-red-950/30 text-red-500 text-sm font-medium">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-14 bg-white text-black hover:bg-neutral-200 hover:text-black rounded-none font-black text-lg uppercase tracking-widest border-2 border-white transition-all mt-8">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Processing...
          </> : "Join"}
      </Button>
    </Form>;
}